var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.view == _vm.views.error
        ? _c("error", { attrs: { error_msg: _vm.error_msg } })
        : _vm.view == _vm.views.asta
        ? _c("asta")
        : _c("splash"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }